import PropTypes from "prop-types";

export const _PageTransition = {
  children: PropTypes.node,
};

export const PageTransitionPropTypes = _PageTransition;
